import React from 'react';

import './Footer.css';

export const Footer = () => {
  return (
    <div className="footer-container">
      <div className="left-content-container">
        <div className="map-container">
          <iframe
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
            // allowfullscreen
            src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJFy1XFXGD54gRDVzaRx4K5G0&key=AIzaSyCJH8w6pFbOUfA1qwB1CeztrQ_W1THyFZw"
          ></iframe>
        </div>

        <div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              color: '#ffffff',
            }}
          >
            <h3>Contact Information</h3>

            <a>auctions@ridenow.com</a>

            <a>Phone: (844) 227-8628</a>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '2%',
              color: '#ffffff',
            }}
          >
            <h3>Hours</h3>

            <h3 style={{ marginTop: 0 }}>Friday 9AM-5PM</h3>
            <h3 style={{ marginTop: 0 }}>Saturday 9AM-5PM</h3>
            <h3 style={{ marginTop: 0 }}>Sunday Closed</h3>
            <h3 style={{ marginTop: 0 }}>Monday 9AM-5PM</h3>
            <h3 style={{ marginTop: 0 }}>Tuesday 9AM-5PM</h3>
            <h3 style={{ marginTop: 0 }}>Wednesday 9AM-5PM</h3>
            <h3 style={{ marginTop: 0 }}>Thursday 9AM-5PM</h3>
          </div>
        </div>
      </div>

      <div className="right-content-container">
        <div style={{ color: '#ffffff' }}>
          <img src="https://www.ridenowauctions.com/wp-content/uploads/2022/11/ridenoworlando-logo.png" />

          <div className="quick-links-container">
            <h3>Quick Links</h3>

            <h3>
              <a href="https://www.ridenowauctions.com/">+ Home</a>
            </h3>
            <h3>
              <a href="https://ridenowauctions.com/auctions/catalog/id/3">
                + Auction
              </a>
            </h3>
            <h3>
              <a href="https://ridenowauctions.com/login">+ Sign in</a>
            </h3>
            <h3>
              <a href="https://ridenowauctions.com/signup">+ Sign up</a>
            </h3>
            <h3>
              <a href="https://secure-financing.dealerspike.com/financeapp/finance_app.php?dealership=ridenoworlando&did=11030&locale=en-us">
                + Get Prequalified
              </a>
            </h3>
            <h3>
              <a href="https://rumbleonauctions.s3.amazonaws.com/Auction+Terms+and+Conditions.pdf">
                + Terms and Conditions
              </a>
            </h3>
            <h3>
              <a href="https://ridenowauctions.com/login">+ FAQ's</a>
            </h3>
          </div>
        </div>

        <div></div>
      </div>
    </div>
  );
};
